// import React, { useEffect } from "react";
// import { toast } from "react-toastify";

// const DisableCopyPaste = ({ children }) => {
//   useEffect(() => {
//     const handleCopy = (e) => {
//       e.preventDefault();
//       toast.warning("Copy/pasting is not allowed");
//     };

//     const handlePaste = (e) => {
//       e.preventDefault();
//       toast.warning("Copy/pasting is not allowed");
//     };

//     const handleCut = (e) => {
//       e.preventDefault();
//       toast.warning("Copy/pasting is not allowed");
//     };

//     document.addEventListener("copy", handleCopy);
//     document.addEventListener("paste", handlePaste);
//     document.addEventListener("cut", handleCut);

//     return () => {
//       document.removeEventListener("copy", handleCopy);
//       document.removeEventListener("paste", handlePaste);
//       document.removeEventListener("cut", handleCut);
//     };
//   }, []);

//   return <>{children}</>;
// };

// export default DisableCopyPaste;



import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
const DisableCopyPaste = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    //  Allow copy-paste on "/"
    if (location.pathname === "/") {
      return;
    }
    const handleCopy = (e) => {
      e.preventDefault();
      toast.warning("Copy/pasting is not allowed");
    };
    const handlePaste = (e) => {
      e.preventDefault();
      toast.warning("Copy/pasting is not allowed");
    };
    const handleCut = (e) => {
      e.preventDefault();
      toast.warning("Copy/pasting is not allowed");
    };
    document.addEventListener("copy", handleCopy);
    document.addEventListener("paste", handlePaste);
    document.addEventListener("cut", handleCut);
    //  cleanup when route changes
    return () => {
      document.removeEventListener("copy", handleCopy);
      document.removeEventListener("paste", handlePaste);
      document.removeEventListener("cut", handleCut);
    };
  }, [location.pathname]); //  KEY FIX
  return <>{children}</>;
};
export default DisableCopyPaste;